unit UEditPasswordForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, UMainConfig, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, Types, Vcl.Grids,
  WEBLib.Grids, WEBLib.Buttons, UStampModel;

type
  TEditPasswordForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlStatus: TPanel;
    sgStatus: TStringGrid;
    pnlData: TPanel;
    WebLabel1: TLabel;
    WebLabel4: TLabel;
    edtPassword: TEdit;
    edtPassword1: TEdit;
    WebLabel2: TLabel;
    edtPassword2: TEdit;
    btnPwShow: TBitBtn;
    btnPwHide: TBitBtn;
    btnPw1Show: TBitBtn;
    btnPw1Hide: TBitBtn;
    btnPw2Show: TBitBtn;
    btnPw2Hide: TBitBtn;
    btnStore: TBitBtn;
    procedure WebFormResize(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure btnPwShowClick(Sender: TObject);
    procedure btnPwHideClick(Sender: TObject);
    procedure btnPw1ShowClick(Sender: TObject);
    procedure btnPw1HideClick(Sender: TObject);
    procedure btnPw2HideClick(Sender: TObject);
    procedure btnPw2ShowClick(Sender: TObject);
    procedure btnStoreClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
    procedure edtPassword2KeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure WebFormCreate(Sender: TObject);
  private
    FMainConfig: TMainConfig;
    FFakStamp: TStampModel;
    FStamp: TStampModel;
    function CheckMask: Boolean;
    procedure Error(Sender: TObject; AMsg: string);
    procedure GetLastFakStamp;
    procedure GetStatus;
    procedure PwCorrect(Sender: TObject);
    procedure StoreCallback(Sender: TObject);
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetFakStamp(const Value: TStampModel);
    procedure SetStamp(const Value: TStampModel);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property Stamp: TStampModel read FStamp write SetStamp;
    property FakStamp: TStampModel read FFakStamp write SetFakStamp;
  protected procedure LoadDFMValues; override; end;

var
  EditPasswordForm: TEditPasswordForm;

implementation

uses
  UUserModel, UEssentialHelper, UGridHelper;

{$R *.dfm}
{ TEditPasswordForm }

procedure TEditPasswordForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TEditPasswordForm.btnPw1HideClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  edtPassword1.PasswordChar := '*';
  btnPw1Hide.Visible := false;
  btnPw1Show.Visible := true;
end;

procedure TEditPasswordForm.btnPw1ShowClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  edtPassword1.PasswordChar := #0;
  btnPw1Show.Visible := false;
  btnPw1Hide.Visible := true;
end;

procedure TEditPasswordForm.btnPw2HideClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  edtPassword2.PasswordChar := '*';
  btnPw2Hide.Visible := false;
  btnPw2Show.Visible := true;
end;

procedure TEditPasswordForm.btnPw2ShowClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  edtPassword2.PasswordChar := #0;
  btnPw2Show.Visible := false;
  btnPw2Hide.Visible := true;
end;

procedure TEditPasswordForm.btnPwHideClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  edtPassword.PasswordChar := '*';
  btnPwHide.Visible := false;
  btnPwShow.Visible := true;
end;

procedure TEditPasswordForm.btnPwShowClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  edtPassword.PasswordChar := #0;
  btnPwShow.Visible := false;
  btnPwHide.Visible := true;
end;

procedure TEditPasswordForm.btnStoreClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  if Self.CheckMask then
    TUserModel.IsPwCorrect(Self.MainConfig.Uri,
      Self.MainConfig.User.Remote_User, edtPassword.Text, @PwCorrect, @Error);
end;

function TEditPasswordForm.CheckMask: Boolean;
var
  error: string;
begin
  error := '';
  if (error = '') and (edtPassword1.Text = '') then
  begin
    error := 'Ihr neues Passwort darf nicht leer sein!';
    edtPassword1.SetFocus;
  end;
  if (error = '') and (edtPassword1.Text <> edtPassword2.Text) then
  begin
    error := 'Ihr neues Passwort und deren Wiederholung sind nicht identisch!';
    edtPassword2.SetFocus;
  end;
  if error <> '' then
    MessageDLG(error, mtWarning, [mbOK]);
  Result := error = '';
end;

procedure TEditPasswordForm.edtPassword2KeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  Self.MainConfig.TimerReset;
end;

procedure TEditPasswordForm.Error(Sender: TObject; AMsg: string);
begin
  MessageDLG(AMsg,mtError,[mbOk],nil);
end;

procedure TEditPasswordForm.GetLastFakStamp;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.FakStamp:=Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastFakStamp(Self.MainConfig.Uri);
end;

procedure TEditPasswordForm.GetStatus;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.Stamp:=Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastStamp(Self.MainConfig.Uri);
end;

procedure TEditPasswordForm.PwCorrect(Sender: TObject);
begin
  if Sender is TBooleanValue then
  begin
    if (Sender as TBooleanValue).Value then
    begin
      Self.MainConfig.User.OnPropertyChanged := StoreCallback;
      Self.MainConfig.User.UpdatePassword(Self.MainConfig.Uri,
        edtPassword1.Text);
    end
    else
      MessageDLG('Ihr altes Passwort ist nicht korrekt!', mtWarning, [mbOK]);
  end;
end;

procedure TEditPasswordForm.SetFakStamp(const Value: TStampModel);
begin
  FFakStamp := Value;
end;

procedure TEditPasswordForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
    Self.GetLastFakStamp;
  Self.WebFormResize(Self);
  Self.GetStatus;
  Self.GetLastFakStamp;
end;

procedure TEditPasswordForm.SetStamp(const Value: TStampModel);
begin
  FStamp := Value;
end;

procedure TEditPasswordForm.StoreCallback(Sender: TObject);
begin
  if Sender is TUserModel then
  begin
    if (Sender as TUserModel).Result.ResultValue then
    begin
      MessageDLG('Passwort erfolgreich geändert.', mtInformation, [mbOK]);
      Self.Close;
    end
    else
      MessageDLG((Sender as TUserModel).Result.ResultMessage,
        mtWarning, [mbOK]);
  end;
end;

procedure TEditPasswordForm.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  if Self.MainConfig <> nil then
    Self.MainConfig.User.OnPropertyChanged := nil;
end;

procedure TEditPasswordForm.WebFormCreate(Sender: TObject);
begin
  Self.Stamp:=nil;
  Self.FakStamp:=nil;
end;

procedure TEditPasswordForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TEditPasswordForm.WebFormResize(Sender: TObject);
var
  i: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Passwort ändern';
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, true, pnlStatus,
        Self.MainConfig.User);
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Passwort ändern';
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, false, pnlStatus,
        Self.MainConfig.User);
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - btnBack.Width - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  i := (Self.ClientWidth - pnlData.Width) div 2;
  if i < 0 then
    i := 0;
  pnlData.Left := i;
  i := Self.ClientHeight - pnlHeader.Height - pnlStatus.Height - pnlData.Height;
  if pnlFooter.Visible then
    i := i - pnlFooter.Height;
  i := i div 2;
  if i < 0 then
    i := 0;
  pnlData.Top := pnlStatus.Top + pnlStatus.Height + i;
end;

procedure TEditPasswordForm.WebFormShow(Sender: TObject);
begin
  Self.WebFormResize(Sender);
  btnPwShow.Visible := true;
  btnPwHide.Visible := false;
  btnPwHide.Top := btnPwShow.Top;
  btnPwHide.Left := btnPwShow.Left;
  edtPassword.PasswordChar := '*';
  btnPw1Show.Visible := true;
  btnPw1Hide.Visible := false;
  btnPw1Hide.Top := btnPw1Show.Top;
  btnPw1Hide.Left := btnPw1Show.Left;
  edtPassword1.PasswordChar := '*';
  btnPw2Show.Visible := true;
  btnPw2Hide.Visible := false;
  btnPw2Hide.Top := btnPw2Show.Top;
  btnPw2Hide.Left := btnPw2Show.Left;
  edtPassword2.PasswordChar := '*';
  edtPassword.Text := '';
  edtPassword1.Text := '';
  edtPassword2.Text := '';
end;

procedure TEditPasswordForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlStatus := TPanel.Create(Self);
  sgStatus := TStringGrid.Create(Self);
  pnlData := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  edtPassword := TEdit.Create(Self);
  edtPassword1 := TEdit.Create(Self);
  edtPassword2 := TEdit.Create(Self);
  btnPwShow := TBitBtn.Create(Self);
  btnPwHide := TBitBtn.Create(Self);
  btnPw1Show := TBitBtn.Create(Self);
  btnPw1Hide := TBitBtn.Create(Self);
  btnPw2Show := TBitBtn.Create(Self);
  btnPw2Hide := TBitBtn.Create(Self);
  btnStore := TBitBtn.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlStatus.BeforeLoadDFMValues;
  sgStatus.BeforeLoadDFMValues;
  pnlData.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  edtPassword.BeforeLoadDFMValues;
  edtPassword1.BeforeLoadDFMValues;
  edtPassword2.BeforeLoadDFMValues;
  btnPwShow.BeforeLoadDFMValues;
  btnPwHide.BeforeLoadDFMValues;
  btnPw1Show.BeforeLoadDFMValues;
  btnPw1Hide.BeforeLoadDFMValues;
  btnPw2Show.BeforeLoadDFMValues;
  btnPw2Hide.BeforeLoadDFMValues;
  btnStore.BeforeLoadDFMValues;
  try
    Name := 'EditPasswordForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnScroll', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UEditPasswordForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Passwort '#228'ndern';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UEditPasswordForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlStatus.SetParentComponent(Self);
    pnlStatus.Name := 'pnlStatus';
    pnlStatus.Left := 0;
    pnlStatus.Top := 64;
    pnlStatus.Width := 640;
    pnlStatus.Height := 28;
    pnlStatus.Align := alTop;
    pnlStatus.Caption := 'pnlStatus';
    pnlStatus.ChildOrder := 2;
    pnlStatus.ShowCaption := False;
    sgStatus.SetParentComponent(pnlStatus);
    sgStatus.Name := 'sgStatus';
    sgStatus.Left := 0;
    sgStatus.Top := 0;
    sgStatus.Width := 640;
    sgStatus.Height := 28;
    sgStatus.Align := alClient;
    sgStatus.ColCount := 4;
    sgStatus.FixedCols := 0;
    sgStatus.RowCount := 2;
    sgStatus.FixedRows := 0;
    sgStatus.Font.Charset := ANSI_CHARSET;
    sgStatus.Font.Color := clNavy;
    sgStatus.Font.Height := -16;
    sgStatus.Font.Name := 'Segoe UI Semibold';
    sgStatus.Font.Style := [fsBold];
    sgStatus.Options := [goRangeSelect,goFixedRowDefAlign];
    sgStatus.ParentFont := False;
    sgStatus.ScrollBars := ssNone;
    sgStatus.TabOrder := 0;
    sgStatus.RangeEdit.Max := 100.000000000000000000;
    sgStatus.RangeEdit.Step := 1.000000000000000000;
    sgStatus.HeightPercent := 100.000000000000000000;
    sgStatus.WidthPercent := 100.000000000000000000;
    pnlData.SetParentComponent(Self);
    pnlData.Name := 'pnlData';
    pnlData.Left := 185;
    pnlData.Top := 138;
    pnlData.Width := 208;
    pnlData.Height := 208;
    pnlData.Caption := 'pnlData';
    pnlData.ChildOrder := 3;
    pnlData.ShowCaption := False;
    WebLabel1.SetParentComponent(pnlData);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 8;
    WebLabel1.Width := 113;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Ihr aktuelles Passwort';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(pnlData);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 8;
    WebLabel4.Top := 56;
    WebLabel4.Width := 98;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Ihr neues Passwort';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(pnlData);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 8;
    WebLabel2.Top := 104;
    WebLabel2.Width := 184;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Ihr neues Passwort (Wiederholung)';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    edtPassword.SetParentComponent(pnlData);
    edtPassword.Name := 'edtPassword';
    edtPassword.Left := 8;
    edtPassword.Top := 24;
    edtPassword.Width := 100;
    edtPassword.Height := 22;
    edtPassword.ChildOrder := 1;
    edtPassword.HeightPercent := 100.000000000000000000;
    edtPassword.MaxLength := 10;
    edtPassword.PasswordChar := '*';
    edtPassword.Text := 'edtPassword';
    edtPassword.WidthPercent := 100.000000000000000000;
    SetEvent(edtPassword, Self, 'OnKeyDown', 'edtPassword2KeyDown');
    edtPassword1.SetParentComponent(pnlData);
    edtPassword1.Name := 'edtPassword1';
    edtPassword1.Left := 8;
    edtPassword1.Top := 72;
    edtPassword1.Width := 100;
    edtPassword1.Height := 22;
    edtPassword1.ChildOrder := 1;
    edtPassword1.HeightPercent := 100.000000000000000000;
    edtPassword1.MaxLength := 10;
    edtPassword1.PasswordChar := '*';
    edtPassword1.TabOrder := 1;
    edtPassword1.Text := 'edtPassword1';
    edtPassword1.WidthPercent := 100.000000000000000000;
    SetEvent(edtPassword1, Self, 'OnKeyDown', 'edtPassword2KeyDown');
    edtPassword2.SetParentComponent(pnlData);
    edtPassword2.Name := 'edtPassword2';
    edtPassword2.Left := 8;
    edtPassword2.Top := 120;
    edtPassword2.Width := 100;
    edtPassword2.Height := 22;
    edtPassword2.ChildOrder := 1;
    edtPassword2.HeightPercent := 100.000000000000000000;
    edtPassword2.MaxLength := 10;
    edtPassword2.PasswordChar := '*';
    edtPassword2.TabOrder := 2;
    edtPassword2.Text := 'edtPassword2';
    edtPassword2.WidthPercent := 100.000000000000000000;
    SetEvent(edtPassword2, Self, 'OnKeyDown', 'edtPassword2KeyDown');
    btnPwShow.SetParentComponent(pnlData);
    btnPwShow.Name := 'btnPwShow';
    btnPwShow.Left := 120;
    btnPwShow.Top := 24;
    btnPwShow.Width := 22;
    btnPwShow.Height := 22;
    btnPwShow.Hint := 'Passwort anzeigen';
    btnPwShow.Color := clNone;
    btnPwShow.Glyph.LoadFromFile('UEditPasswordForm.pnlData.btnPwShow.Glyph.png');
    btnPwShow.GlyphSize := 16;
    btnPwShow.HeightPercent := 100.000000000000000000;
    btnPwShow.ShowHint := True;
    btnPwShow.WidthPercent := 100.000000000000000000;
    SetEvent(btnPwShow, Self, 'OnClick', 'btnPwShowClick');
    btnPwHide.SetParentComponent(pnlData);
    btnPwHide.Name := 'btnPwHide';
    btnPwHide.Left := 156;
    btnPwHide.Top := 24;
    btnPwHide.Width := 22;
    btnPwHide.Height := 22;
    btnPwHide.Hint := 'Passwort verbergen';
    btnPwHide.Color := clNone;
    btnPwHide.Glyph.LoadFromFile('UEditPasswordForm.pnlData.btnPwHide.Glyph.png');
    btnPwHide.GlyphSize := 16;
    btnPwHide.HeightPercent := 100.000000000000000000;
    btnPwHide.ShowHint := True;
    btnPwHide.WidthPercent := 100.000000000000000000;
    SetEvent(btnPwHide, Self, 'OnClick', 'btnPwHideClick');
    btnPw1Show.SetParentComponent(pnlData);
    btnPw1Show.Name := 'btnPw1Show';
    btnPw1Show.Left := 120;
    btnPw1Show.Top := 72;
    btnPw1Show.Width := 22;
    btnPw1Show.Height := 22;
    btnPw1Show.Hint := 'Passwort anzeigen';
    btnPw1Show.Color := clNone;
    btnPw1Show.Glyph.LoadFromFile('UEditPasswordForm.pnlData.btnPw1Show.Glyph.png');
    btnPw1Show.GlyphSize := 16;
    btnPw1Show.HeightPercent := 100.000000000000000000;
    btnPw1Show.ShowHint := True;
    btnPw1Show.WidthPercent := 100.000000000000000000;
    SetEvent(btnPw1Show, Self, 'OnClick', 'btnPw1ShowClick');
    btnPw1Hide.SetParentComponent(pnlData);
    btnPw1Hide.Name := 'btnPw1Hide';
    btnPw1Hide.Left := 156;
    btnPw1Hide.Top := 72;
    btnPw1Hide.Width := 22;
    btnPw1Hide.Height := 22;
    btnPw1Hide.Hint := 'Passwort verbergen';
    btnPw1Hide.Color := clNone;
    btnPw1Hide.Glyph.LoadFromFile('UEditPasswordForm.pnlData.btnPw1Hide.Glyph.png');
    btnPw1Hide.GlyphSize := 16;
    btnPw1Hide.HeightPercent := 100.000000000000000000;
    btnPw1Hide.ShowHint := True;
    btnPw1Hide.WidthPercent := 100.000000000000000000;
    SetEvent(btnPw1Hide, Self, 'OnClick', 'btnPw1HideClick');
    btnPw2Show.SetParentComponent(pnlData);
    btnPw2Show.Name := 'btnPw2Show';
    btnPw2Show.Left := 120;
    btnPw2Show.Top := 120;
    btnPw2Show.Width := 22;
    btnPw2Show.Height := 22;
    btnPw2Show.Hint := 'Passwort anzeigen';
    btnPw2Show.Color := clNone;
    btnPw2Show.Glyph.LoadFromFile('UEditPasswordForm.pnlData.btnPw2Show.Glyph.png');
    btnPw2Show.GlyphSize := 16;
    btnPw2Show.HeightPercent := 100.000000000000000000;
    btnPw2Show.ShowHint := True;
    btnPw2Show.WidthPercent := 100.000000000000000000;
    SetEvent(btnPw2Show, Self, 'OnClick', 'btnPw2ShowClick');
    btnPw2Hide.SetParentComponent(pnlData);
    btnPw2Hide.Name := 'btnPw2Hide';
    btnPw2Hide.Left := 156;
    btnPw2Hide.Top := 120;
    btnPw2Hide.Width := 22;
    btnPw2Hide.Height := 22;
    btnPw2Hide.Hint := 'Passwort verbergen';
    btnPw2Hide.Color := clNone;
    btnPw2Hide.Glyph.LoadFromFile('UEditPasswordForm.pnlData.btnPw2Hide.Glyph.png');
    btnPw2Hide.GlyphSize := 16;
    btnPw2Hide.HeightPercent := 100.000000000000000000;
    btnPw2Hide.ShowHint := True;
    btnPw2Hide.WidthPercent := 100.000000000000000000;
    SetEvent(btnPw2Hide, Self, 'OnClick', 'btnPw2HideClick');
    btnStore.SetParentComponent(pnlData);
    btnStore.Name := 'btnStore';
    btnStore.Left := 8;
    btnStore.Top := 152;
    btnStore.Width := 192;
    btnStore.Height := 48;
    btnStore.Caption := #196'ndern';
    btnStore.Color := clNone;
    btnStore.Glyph.LoadFromFile('UEditPasswordForm.pnlData.btnStore.Glyph.png');
    btnStore.GlyphSize := 32;
    btnStore.HeightPercent := 100.000000000000000000;
    btnStore.TabOrder := 3;
    btnStore.WidthPercent := 100.000000000000000000;
    SetEvent(btnStore, Self, 'OnClick', 'btnStoreClick');
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlStatus.AfterLoadDFMValues;
    sgStatus.AfterLoadDFMValues;
    pnlData.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    edtPassword.AfterLoadDFMValues;
    edtPassword1.AfterLoadDFMValues;
    edtPassword2.AfterLoadDFMValues;
    btnPwShow.AfterLoadDFMValues;
    btnPwHide.AfterLoadDFMValues;
    btnPw1Show.AfterLoadDFMValues;
    btnPw1Hide.AfterLoadDFMValues;
    btnPw2Show.AfterLoadDFMValues;
    btnPw2Hide.AfterLoadDFMValues;
    btnStore.AfterLoadDFMValues;
  end;
end;

end.
